async function getMytimeslotsAPI() {
  const result = await window.fetch('/webapi/timeslots/api/v1/timeslots/my', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return result;
}

export default getMytimeslotsAPI;
